<template lang="pug">

    div
        v-hover(v-slot:default='{ hover }' v-for='activity in activities' :key='activity.ticket_activity_id')
            v-row.no-margin.dashed-border(
                :class="{ 'super-admin-activity': activity.super_admin_activity }" 
                :style="{ 'display': (activity.super_admin_activity || activity.escalated_to_engineering_changed) && !currentUserIsSuperAdmin ? 'none' : '' }"
                )
                v-col.col-8(v-if="activity.ticket_reopened")
                    strong Reopened ticket
                    v-container(v-if="activity.comments_message" style="padding: 12px 0;" v-html="activity.comments_message")

                v-col.col-8(v-if="!activity.ticket_reopened")
                    v-col.no-padding
                        span(v-if="activity.super_admin_activity").super-admin-activity-label admin only
                    v-col.no-padding
                        em(v-if="activity.title_changed") Updated title
                    v-col.no-padding
                        em(v-if="activity.description_changed") Updated description
                    v-col.no-padding
                        em(v-if="activity.ticket_assignment_changed") Assigned ticket to Volie {{ activity.assigned_to | titleize }}
                    v-col.no-padding
                        em(v-if="activity.ticket_type_changed") Updated ticket type to {{ activity.ticket_type }}
                    v-col.no-padding
                        em(v-if="activity.priority_changed && currentUserIsSuperAdmin") Updated priority to {{ activity.priority }}
                    v-col.no-padding
                        em(v-if="activity.current_status_changed") Updated status to {{ activity.current_status }}
                    v-col.no-padding
                        em(v-if="activity.completion_code_changed") Updated completion code to {{ activity.completion_code }}
                    v-col.no-padding
                        em(v-if="activity.internal_development_estimate_hours_changed && currentUserIsSuperAdmin") Updated development estimate hours to {{ activity.internal_development_estimate_hours }}
                    v-col.no-padding
                        em(v-if="activity.internal_development_actual_hours_changed && currentUserIsSuperAdmin") Updated development actual hours to {{ activity.internal_development_actual_hours }}
                    v-col.no-padding
                        em(v-if="activity.internal_development_priority_changed && currentUserIsSuperAdmin") Updated development priority to {{ activity.internal_development_priority }}
                    v-col.no-padding
                        em(v-if="activity.internal_development_size_changed && currentUserIsSuperAdmin") Updated development size to {{ activity.internal_development_size }}
                    v-col.no-padding
                        em(v-if="activity.ticket_category_id_changed") Updated category to {{ activity.ticket_category_name }}
                    v-col.no-padding
                        em(v-if="activity.affected_app_page_changed") Updated affected app page to {{ activity.affected_app_page }}
                    v-col.no-padding
                        em(v-if="activity.ticket_flag_ids_changed && currentUserIsSuperAdmin") Updated ticket flags
                    v-col.no-padding
                        em(v-if="activity.internal_development_stage_changed && currentUserIsSuperAdmin") Updated development stage to {{ activity.internal_development_stage }}
                    v-col.no-padding
                        em(v-if="activity.mediaable_id") Uploaded attachment
                    v-col.no-padding
                        em(v-if="activity.comments_message") Comment added 
                    v-col.no-padding
                        v-row(v-if="activity.escalated_to_engineering_changed" style="margin: 0px;")
                            em Ticket Escalated to Engineering - 
                            a.ml-2(:href="'https://volie.atlassian.net/browse/' + activity.jira_issue_key") {{ ' ' + activity.jira_issue_key }}
                    v-col.no-padding
                        v-container(v-if="activity.comments_message" style="padding: 12px 0px 0px;" v-html="activity.comments_message")
                    
                    template(v-if="isSourceAdmin")
                        v-col.no-padding(v-show='!!hover')
                            v-btn(
                                v-if="activity.comments_message"
                                small
                                color='warning'
                                dark
                                @click="onUpdateComment(activity)"
                            )
                                v-icon(small) mdi-comment-edit-outline
                            v-btn(
                                v-else
                                small
                                color='info'
                                dark
                                @click="onUpdateComment(activity)"
                                style="margin-top: 12px;"
                            )
                                v-icon(small) mdi-comment-plus-outline
                v-col.col-4
                    v-row.no-margin
                        v-col.activity-cell
                            strong {{ activity.display_name }}

                    v-row.no-margin
                        v-col.activity-cell
                            strong {{ activity.friendly_created_at }}
                    template(v-if="activity.mediaable_id")
                        v-row.no-margin
                            v-col.activity-cell
                                strong Uploaded attachment

                v-col(v-if="activity.mediaable_id" cols=12)
                    template(v-if="activity.asset_file_type === 'image'")
                        v-row.no-margin
                            v-col
                                a(:href="activity.asset_url"  target="_blank")
                                    v-img(contain max-height='250' max-width='250' :src='activity.asset_url')
                            v-col.text-right
                                ShowImageDialog(
                                    :image-url="activity.asset_url"
                                )
                    template(v-else-if="activity.asset_file_type === 'audio' || activity.asset_content_type === 'audio/mp3'")
                        v-row.no-margin
                            v-col
                                VolieAudio(
                                    :file="activity.asset_url"
                                    color="success"
                                    downloadable=true
                                )
                    template(v-else)
                        a(:href="activity.asset_url" target="_blank")
                            | {{ activity.original_file_name || activity.asset_file_name || activity.asset_url || 'Download' }}


</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Components
    import ShowImageDialog from '@/components/tickets/partials/show_image_dialog.vue';
    import VolieAudio from '@/components/shared/audio_player.vue';

    export default Vue.extend({
        data() {
            return {
                formTag: null,
                snackbar: {
                    show: false,
                    timeout: 2500,
                },
            }
        },
        methods: {
            onUpdateComment(activity) {
                if (this.updateComment) {
                    this.updateComment(activity)
                }
            },
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            currentUserIsSuperAdmin() {
                return this.currentUser?.activated_role_id === 1;
            },
            isSourceAdmin() {
                return this.source === "admin";
            },
        },
        components: {
            ShowImageDialog,
            VolieAudio,
        },
        props: {
            activities: Array,
            source: String,
            updateComment: Function,
        },
        created() {},
    });
</script>

<style lang="scss" scoped>
.no-margin {
    margin: 0;
}
.no-padding {
    padding: 0;
}
.activity-cell {
    text-align: right !important;
    padding: 6px 0;
    font-size: 12px;
}
.dashed-border {
    border-bottom: 1px dashed #cfdadd;
}
.super-admin-activity-label {
    color: #48c1c3;
    font-weight: bold;
    text-transform: uppercase;
}
.super-admin-activity {
    background-color: rgba(104, 104, 104, 0.1);
}
</style>